import React from "react";

import Heading from "home/components/Heading";
import Footer from "home/components/Footer";
import ContentSection from "home/components/ContentSection";

import styled from "styled-components";

import { Breadcrumbs, Link, Typography } from "@material-ui/core";

const Page = styled.div`
  height: calc(100vh - 85px);
`;

export default () => {
  return (
    <div>
      <Heading maxWidth={1000} showButtons={true} />
      <Page>
        <ContentSection maxWidth={1000}>
          <div>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" href="/">
                RoboPPA Home
              </Link>
              <Link color="inherit" href="/#/Blog">
                Blog Posts
              </Link>
              <Typography color="textPrimary">March 6, 2021</Typography>
            </Breadcrumbs>
          </div>
          <h1>
            The Effect of Contributions and Withdrawals on the Reporting of
            Portfolio Performance
          </h1>
          <h2>
            If there is a single measure of a portfolio’s performance over an
            analysis period, the annualized return is likely the most preferred.
          </h2>
          <h3>The Problem</h3>
          <p>
            Out of pocket cash transfers or security transfers from one
            portfolio to another are a common occurrence. The problem is that
            these contributions and withdrawals seriously affect the calculation
            of a portfolio’s return performance and can easily result in
            contrary results, depending on the reporting return method.
          </p>
          <h3>Common Return Methods</h3>
          <p>
            There are two commonly calculated and published portfolio returns
            for a selected analysis period.
          </p>
          <ol>
            <li>
              Time-Weighted Return (TWR), also called Geometric Return and
              Holding Period Return (HPR)
            </li>
          </ol>
          <p>
            This is an analysis period’s annualized portfolio return if there
            were no contributions or withdrawals (transfers. (The analysis
            period’s monthly returns are converted to the overall analysis
            return by adding 1 to each and computing its geometric average, and
            then annualizing.
          </p>
          <p>
            This may seem like a non-sensical method but was likely developed
            for reporting the same return on a managed portfolio that had many
            owners with differing transfers. This avoided tracking the transfers
            of individual owners that were their decisions rather than those of
            the portfolio manager. The question is, does it represent the
            correct return to a portfolio’s owner? The answer is yes if and only
            if there actually were no transfers.
          </p>
          <ol start="2">
            <li>
              Dollar-Weighted Return, also called Internal Rate of Return (IRR)
            </li>
          </ol>
          <p>
            This is an analysis period’s portfolio return based on the present
            value of the portfolio’s cash flows that include transfers. For an
            analysis period, it is the discount rate (return) that equates the
            present (discounted) value of cash inflows with the discounted value
            of cash outflows. The cash flows are the initial value of the
            portfolio (outflow), the contributions (outflows) and withdrawals
            (inflows), and the portfolio's ending value (inflow). The annualized
            IRR is calculated from the monthly discount rate.
          </p>
          <h3>An Example</h3>
          <p>
            To demonstrate the difference in the return methods and the problems
            with the TWR, we show the RoboPPA™ results from a December 31, 2019,
            $100,000 investment in the market index, with a $20,000 portfolio
            contribution made post crash on March 31, 2020 and also invested in
            the market index. Therefore, the portfolio was held over the March
            2020 crash, with a post crash contribution, and analyzed over the
            analysis period starting December 31, 2019 and ending August 31,
            2020.
          </p>
          <p>
            The resulting IRR is 5.31%/year and the corresponding TWR is -1.58%
            clearly demonstrating the contradictory portfolio returns. In the
            case of no contribution, the two returns are identical at
            -1.58%/year.
          </p>
          <h3>Conclusion</h3>
          <p>
            In this example, the $20,000 contribution was in the portfolio from
            March 31, 2020 until August 31, 2020. The portfolio return was
            positive in every one of those months implying that the contribution
            added value to the portfolio without the contribution. Therefore,
            the overall portfolio’s return must exceed the return without the
            contribution and the IRR is a better representation of the return to
            the owner. In our opinion, the IRR is the preferred measure of a
            managed portfolio’s return to the owner.
          </p>
          <h3>Caveats</h3>
          <p>
            The analysis contained in this document is based on a fictitious
            portfolio and the results are not to be interpreted as
            representative of real markets and asset classes. This example is
            based upon our opinion and interpretation of the information and
            results, which may be incomplete or incorrect. Details on the
            performance calculations are available on www.RoboPPA.com.
          </p>
        </ContentSection>
        <Footer />
      </Page>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/blog/blogPosts/3-6-2021.js